import React, { useEffect, useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setCurrentPage,
  setPageSize,
} from "../../../redux/giftExchange/giftExchangeForCusHistories";
import { useNavigate } from "react-router-dom";
import {
  Empty,
  Input,
  message,
  Modal,
  Select,
  Space,
  TreeSelect,
  DatePicker,
  Tag,
  Button,
  Typography,
} from "antd";
import {
  getListGiftExchangeForCustomerHistories,
  updateStatusGiftExchangeForCustomers,
} from "../../../api/giftExchange/giftExchange";
import { formatDateTimeCustomize } from "../../../utils/dateTime";
import { store } from "../../../redux/configStore";
import { settings } from "../../../utils/config";
import useStoreData from "../../../hooks/useStoreData";
import { transformData } from "../../../utils/recursive";
import {
  GiftOutlined,
  HistoryOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";
import ButtonWithPermission from "../../../components/ButtonWithPermission/ButtonWithPermission";
import dayjs from "dayjs";
import { giftExchangeAPIWithErrorHandling } from "../../../api/giftExchange/giftExchangeApi";
import BrandedPageLayout from "../../../components/Dashboard/BrandedPageLayout";
import StatStrip from "../../../components/cms/StatStrip";
import ListToolbar from "../../../components/cms/ListToolbar";
import ImportExportMenu from "../../../components/cms/ImportExportMenu";
import CmsTableCard from "../../../components/cms/CmsTableCard";
import StatusTag from "../../../components/cms/StatusTag";
import { neutral, brand, semantic, spacing, typography } from "../../../theme/tokens";

const { Text } = Typography;

const FILTER_DEFS = [
  { key: "branch", label: "Đơn vị" },
  { key: "category", label: "Loại quà tặng" },
  { key: "status", label: "Trạng thái" },
  { key: "date", label: "Khoảng thời gian" },
];


// address_send_gift lưu dạng JSON string trong DB — parse an toàn về object {name,phone,address,note}.
const parseAddr = (raw) => {
  if (!raw) return {};
  if (typeof raw === "object") return raw;
  try {
    const obj = JSON.parse(raw);
    return obj && typeof obj === "object" ? obj : {};
  } catch {
    return {};
  }
};

const GiftExchangeForCustomerHistories = () => {
  const {
    listGiftExchangeForCustomerHistories,
    isLoadGiftExchangeForCustomerHistories,
    currentPage,
    pageSize,
    totalRecords,
  } = useSelector(
    (state) => state.persistedReducer.giftExchangeForCusHistorySlice
  );

  const { data: allListStore, loading: isLoadStoreAll } = useStoreData();

  const dispatch = useDispatch();
  const [branchIdSearch, setBranchIdSearch] = useState(0);
  const [optionStatus, setOptionStatus] = useState(null);
  const [giftCategory, setGiftCategory] = useState(null);
  const [selectedDates, setSelectedDates] = useState([]);
  const typeUser = settings?.getCookie("type_user");

  const [dashboard, setDashboard] = useState({
    total: 0,
    total_giftsended: 0,
    total_giftsend: 0,
  });

  const { RangePicker } = DatePicker;
    const navigate = useNavigate();


  const dataTree = transformData(allListStore?.data);
  const options = dataTree?.filter((item) => item.parent_id === 0);
  const handleSearch = (value = 0) => {
    setBranchIdSearch(value);
  };

  const handleStatus = (value) => {
    setOptionStatus(value);
  };

  const handleGiftCategory = (value) => {
    setGiftCategory(value);
  };

  const handleDateChange = (dates, dateStrings) => {
    setSelectedDates(dateStrings);
  };

  useEffect(() => {
    dispatch(
      getListGiftExchangeForCustomerHistories({
        currentPage,
        pageSize,
        mcouponBranchId: branchIdSearch,
        status: optionStatus,
        type: giftCategory,
        selectedDates: selectedDates,
      })
    );
  }, [
    dispatch,
    currentPage,
    pageSize,
    branchIdSearch,
    optionStatus,
    giftCategory,
    selectedDates,
  ]);
  
  const fetchDashboard = async () => {
    try {
        const response = await giftExchangeAPIWithErrorHandling.getDashboard({
          mcouponBranchId: branchIdSearch,
          status: optionStatus,
          type: giftCategory,
          selectedDates: selectedDates,
        });
        
        if (response?.data?.success) {
          setDashboard(response?.data?.data);
        }
    } catch (error) {
        message.error(error.message);
    }
  };

  useEffect(() => {
    fetchDashboard();
  }, [branchIdSearch, optionStatus, giftCategory, selectedDates]);


  const handlePageChange = (page) => dispatch(setCurrentPage(page));

  const handleSizeChange = useCallback(
    (_, size) => dispatch(setPageSize(size)),
    [dispatch]
  );

  const [editAddr, setEditAddr] = useState(null);
  const [addrForm, setAddrForm] = useState({ name: "", phone: "", address: "", note: "" });
  const [savingAddr, setSavingAddr] = useState(false);

  const openEditAddr = (record) => {
    const a = parseAddr(record.address_send_gift);
    setAddrForm({
      name: a.name || a.recipient_name || "",
      phone: a.phone || "",
      address: a.address || "",
      note: a.note || "",
    });
    setEditAddr(record);
  };

  const handleSaveAddr = async () => {
    if (savingAddr || !editAddr) return;
    if (!addrForm.name.trim() || !addrForm.phone.trim() || !addrForm.address.trim()) {
      message.error("Vui lòng nhập đủ Họ tên, SĐT và Địa chỉ");
      return;
    }
    setSavingAddr(true);
    try {
      await giftExchangeAPIWithErrorHandling.updateGiftAddress({
        history_id: editAddr.id,
        ...addrForm,
      });
      message.success("Đã cập nhật địa chỉ nhận quà");
      setEditAddr(null);
      await store.dispatch(getListGiftExchangeForCustomerHistories({ currentPage, pageSize }));
    } catch (error) {
      message.error(error.message || "Cập nhật địa chỉ thất bại");
    } finally {
      setSavingAddr(false);
    }
  };

  const handleConfirm = async (record) => {
    const payload = {
      history_id: record.id,
    };

    try {
      const response = await store.dispatch(
        updateStatusGiftExchangeForCustomers(payload)
      );
      if (updateStatusGiftExchangeForCustomers.fulfilled.match(response)) {
        message.success("Cập nhật trạng thái thành công!");
        await store.dispatch(
          getListGiftExchangeForCustomerHistories({ currentPage, pageSize })
        );
      } else {
        message.error("Có lỗi xảy ra!");
      }
    } catch (error) {
      message.error("Đã xảy ra lỗi!");
    }
  };

  /*
   * Chỉ dựng tham số theo bộ lọc đang xem; phần tải file do `ImportExportMenu` lo (đi
   * qua `downloadExcel` nên có sẵn token, xử lý 401 và bóc message lỗi trong blob).
   * Bản cũ tự gọi axios kèm header, lỗi thì chỉ `console.error` — người dùng bấm Xuất
   * mà không thấy gì xảy ra cũng không biết vì sao.
   */
  const exportParams = {
    ...(branchIdSearch !== 0 ? { mcoupon_branch_id: branchIdSearch } : {}),
    ...(optionStatus !== null && optionStatus !== undefined ? { status: optionStatus } : {}),
    ...(giftCategory ? { type: giftCategory } : {}),
    ...(selectedDates?.length > 0
      ? { start_date: selectedDates[0], end_date: selectedDates[1] }
      : {}),
  };

  const columns = [
    {
      title: "#",
      key: "index",
      fixed: "left",
      width: 50,
      render: (_, __, i) => (
        <Text style={{ color: neutral[400], fontSize: typography.size.sm }}>
          {(currentPage - 1) * pageSize + i + 1}
        </Text>
      ),
    },
    ...(typeUser === "SHOP"
      ? [
          {
            title: "Khách hàng",
            key: "customer",
            fixed: "left",
            width: 180,
            render: (_, r) => (
              <div
                onClick={() => navigate(`/customer-detail/${r.customer_id}`)}
                style={{ cursor: "pointer" }}
              >
                <Text
                  style={{
                    fontWeight: typography.weight.medium,
                    color: brand.accent,
                    display: "block",
                  }}
                >
                  {r.customer_t?.name || "—"}
                </Text>
                <Text style={{ fontSize: typography.size.sm, color: neutral[500] }}>
                  {r.customer_t?.phone || ""}
                </Text>
              </div>
            ),
          },
        ]
      : []),
    {
      title: "Chương trình",
      key: "program",
      width: 200,
      ellipsis: true,
      render: (_, r) => (
        <Text
          ellipsis
          style={{
            maxWidth: 180,
            display: "inline-block",
            color: neutral[800],
            fontWeight: typography.weight.medium,
          }}
        >
          {r.gift_exchange?.name || "—"}
        </Text>
      ),
    },
    {
      title: "Loại thưởng",
      key: "type",
      align: "center",
      width: 120,
      render: (_, r) => {
        const type = r?.gift_exchange?.type;
        return type === "PRODUCT" ? (
          <StatusTag>Vật phẩm</StatusTag>
        ) : type === "DATA" ? (
          <StatusTag>Data</StatusTag>
        ) : (
          <Text style={{ color: neutral[400] }}>—</Text>
        );
      },
    },
    {
      title: "Điểm",
      key: "point",
      align: "right",
      width: 100,
      render: (_, r) => (
        <Text style={{ fontWeight: typography.weight.semibold, color: semantic.danger }}>
          -{Number(r.point).toLocaleString("vi-VN")}
        </Text>
      ),
    },
    {
      title: "Quà tặng",
      key: "gift",
      width: 200,
      ellipsis: true,
      render: (_, r) => {
        const giftType = r.gift_exchange?.type;
        if (giftType === "PRODUCT") {
          return (
            <Space direction="vertical" size={2}>
              {r?.gift_exchange?.products?.map((p) => (
                <Tag key={p.id}>{p.name}</Tag>
              ))}
            </Space>
          );
        }
        if (giftType === "DATA") {
          return (
            <Space direction="vertical" size={2}>
              <Text style={{ color: neutral[700] }}>{r?.gift_exchange?.items?.[0]?.telco}</Text>
              <Text style={{ fontSize: typography.size.sm, color: neutral[500] }}>
                {r?.gift_exchange?.items?.[0]?.data_pack}
              </Text>
            </Space>
          );
        }
        return <Text style={{ color: neutral[400] }}>—</Text>;
      },
    },
    {
      title: "Chi tiết nhận thưởng",
      key: "address",
      width: 300,
      ellipsis: true,
      render: (_, r) => {
        const addr = parseAddr(r?.address_send_gift);
        const parts = [addr.name || addr.recipient_name, addr.phone, addr.address].filter(Boolean);
        const canEdit = typeUser === "SHOP" && !r.status_send_gift;
        return (
          <Space direction="vertical" size={2}>
            {parts.length ? (
              parts.map((p, i) => (
                <Text key={i} style={{ fontSize: typography.size.sm, color: neutral[600] }}>
                  {p}
                </Text>
              ))
            ) : (
              <Text style={{ color: neutral[400] }}>—</Text>
            )}
            {canEdit && (
              <Button type="link" size="small" style={{ padding: 0, height: "auto" }} onClick={() => openEditAddr(r)}>
                {parts.length ? "Sửa địa chỉ" : "Thêm địa chỉ"}
              </Button>
            )}
          </Space>
        );
      },
    },
    {
      title: "Thời gian",
      key: "created_at",
      width: 160,
      render: (_, r) => (
        <Text style={{ fontSize: typography.size.sm, color: neutral[600] }}>
          {formatDateTimeCustomize(r.created_at)}
        </Text>
      ),
    },
    {
      title: "Xác nhận",
      key: "status",
      width: 180,
      fixed: "right",
      render: (_, r) => {
        const isShopUser = typeUser === "SHOP";
        const isProductType = r.gift_exchange?.type === "PRODUCT";
        const statusCode = r.status_send_gift;

        if (isShopUser && isProductType && statusCode === 0) {
          return (
            <ButtonWithPermission
              actions={["gift-exchanges.sentGiftForCustomers"]}
              children="Gửi quà"
              size="small"
              type="primary"
              icon={<GiftOutlined />}
              onClick={() => handleConfirm(r)}
              noPermissionText="Không có quyền"
            />
          );
        }

        if (isShopUser) {
          return (
            <StatusTag tone={statusCode === 1 ? "success" : "warning"} dot>
              {statusCode === 1
                ? "Đã gửi " + dayjs(r.updated_at).format("DD-MM-YYYY HH:mm")
                : "Chưa gửi"}
            </StatusTag>
          );
        }
        return (
          <StatusTag tone={statusCode === 0 ? "info" : "success"} dot>
            {statusCode === 0 ? "Chưa nhận" : "Đã nhận"}
          </StatusTag>
        );
      },
    },
  ];

  // Dải chỉ số (band 2) — số liệu lấy từ API dashboard nên đúng ở mọi trang.
  const stats = [
    {
      title: "Tổng đổi thưởng",
      value: (dashboard.total ?? 0).toLocaleString("vi-VN"),
      icon: <HistoryOutlined style={{ fontSize: 18 }} />,
      color: brand.accent,
    },
    {
      title: "Đã xử lý",
      value: (dashboard.total_giftsended ?? 0).toLocaleString("vi-VN"),
      icon: <CheckCircleOutlined style={{ fontSize: 18 }} />,
      color: semantic.success,
    },
    {
      title: "Chưa xử lý",
      value: (dashboard.total_giftsend ?? 0).toLocaleString("vi-VN"),
      icon: <ClockCircleOutlined style={{ fontSize: 18 }} />,
      ...((dashboard.total_giftsend ?? 0) > 0
        ? { color: semantic.warning, bgColor: semantic.warningSubtle, borderColor: "#FDE68A" }
        : { color: neutral[400] }),
    },
  ];

  return (
    <BrandedPageLayout
      title="Lịch sử đổi thưởng"
      subtitle="Theo dõi các giao dịch đổi điểm lấy quà tặng, trạng thái gửi quà và chi tiết nhận thưởng."
      breadcrumbItems={[
        { title: "Đổi thưởng", path: "/gift-exchanges" },
        { title: "Lịch sử" },
      ]}
    >
      <StatStrip stats={stats} loading={isLoadGiftExchangeForCustomerHistories} span={{ xs: 24, sm: 8 }} />

      <ListToolbar
        filterDefs={FILTER_DEFS}
        filters={{
          branch: (
            <TreeSelect
              style={{ width: "100%" }}
              disabled={isLoadStoreAll}
              placeholder="Đơn vị"
              showSearch
              allowClear
              value={branchIdSearch || undefined}
              filterTreeNode={(inputValue, treeNode) =>
                treeNode.title.toLowerCase().includes(inputValue.toLowerCase())
              }
              onChange={handleSearch}
              treeLine
              treeData={options}
            />
          ),
          category: (
            <Select
              allowClear
              style={{ width: "100%" }}
              placeholder="Loại quà tặng"
              value={giftCategory}
              onChange={handleGiftCategory}
              options={[
                { value: "PRODUCT", label: "Vật phẩm" },
                { value: "DATA", label: "DATA" },
              ]}
            />
          ),
          status: (
            <Select
              allowClear
              style={{ width: "100%" }}
              placeholder="Trạng thái"
              value={optionStatus}
              onChange={handleStatus}
              options={[
                { value: "0", label: "Chưa nhận" },
                { value: "1", label: "Đã nhận" },
              ]}
            />
          ),
          date: (
            <RangePicker
              style={{ width: "100%" }}
              onChange={handleDateChange}
              placeholder={["Từ ngày", "Đến ngày"]}
            />
          ),
        }}
        onHideFilter={(key) => {
          if (key === "branch") handleSearch(0);
          if (key === "category") handleGiftCategory(undefined);
          if (key === "status") handleStatus(undefined);
          if (key === "date") setSelectedDates([]);
        }}
        onClearFilters={() => {
          handleSearch(0);
          handleGiftCategory(undefined);
          handleStatus(undefined);
          setSelectedDates([]);
        }}
        loading={isLoadGiftExchangeForCustomerHistories}
        onReload={() => {
          store.dispatch(getListGiftExchangeForCustomerHistories({ currentPage, pageSize }));
          fetchDashboard();
        }}
        actions={
          typeUser === "SHOP" && (
            <ImportExportMenu
              exportUrl="/api/v1/serviceconnect/export/gift-exchange-histories"
              exportParams={exportParams}
              exportFileName={`LSDQ_${new Date().toISOString().slice(0, 10).replace(/-/g, "_")}.xlsx`}
              exportActions={["export.gift-exchange-histories"]}
            />
          )
        }
      />

      <CmsTableCard
        columns={columns}
        dataSource={listGiftExchangeForCustomerHistories || []}
        rowKey="id"
        loading={isLoadGiftExchangeForCustomerHistories}
        pagination={{
          showTotal: (total, range) => `${range[0]}–${range[1]} / ${total}`,
          onShowSizeChange: handleSizeChange,
          total: totalRecords,
          current: currentPage,
          pageSize,
          onChange: handlePageChange,
        }}
        locale={{
          emptyText: (
            <Empty description="Chưa có lịch sử đổi thưởng" style={{ padding: spacing[8] }} />
          ),
        }}
        bordered
        scroll={{ x: "max-content" }}
      />

      <Modal
        title="Cập nhật địa chỉ nhận quà"
        open={!!editAddr}
        onCancel={() => !savingAddr && setEditAddr(null)}
        onOk={handleSaveAddr}
        okText="Lưu"
        cancelText="Hủy"
        confirmLoading={savingAddr}
        destroyOnClose
      >
        <Space direction="vertical" size={10} style={{ width: "100%" }}>
          <Input
            placeholder="Họ tên người nhận"
            value={addrForm.name}
            onChange={(e) => setAddrForm((s) => ({ ...s, name: e.target.value }))}
          />
          <Input
            placeholder="Số điện thoại"
            value={addrForm.phone}
            onChange={(e) => setAddrForm((s) => ({ ...s, phone: e.target.value }))}
          />
          <Input.TextArea
            placeholder="Địa chỉ nhận quà"
            rows={2}
            value={addrForm.address}
            onChange={(e) => setAddrForm((s) => ({ ...s, address: e.target.value }))}
          />
          <Input
            placeholder="Ghi chú (tuỳ chọn)"
            value={addrForm.note}
            onChange={(e) => setAddrForm((s) => ({ ...s, note: e.target.value }))}
          />
        </Space>
      </Modal>
    </BrandedPageLayout>
  );
};

export default GiftExchangeForCustomerHistories;
